import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import * as React from 'react';
import clsx from 'clsx';
import { useTheme } from '@emotion/react';
import { list } from '../assets/styles/utility';
import { jsx as ___EmotionJSX } from "@emotion/react";
const List = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    as: Component = 'ul',
    className,
    space,
    type,
    border,
    noContrast
  } = _ref,
      rest = _objectWithoutProperties(_ref, ["as", "className", "space", "type", "border", "noContrast"]);

  const theme = useTheme();
  return ___EmotionJSX(Component, _extends({
    ref: ref,
    css: [list.reset, {
      gridTemplateColumns: 'minmax(0, 1fr)',
      // Fix for `pre` tags thay may occur within
      gap: space && theme.space[space]
    }, border && {
      '> li:not(:first-of-type)': [{
        paddingTop: space && theme.space[space],
        borderTop: theme.border.base
      }, theme.settings.contrast.enable && !noContrast && {
        '.u-contrast &': {
          borderColor: theme.contrast.border
        }
      }]
    }, type === 'numbers' && list.numbers({
      theme,
      space: space && theme.space[space],
      border,
      noContrast
    }), type === 'circles' && list.circles({
      theme,
      space: space && theme.space[space],
      border,
      noContrast
    }), process.env.NODE_ENV === "production" ? "" : ";label:List;"],
    className: clsx('CK__List', className)
  }, rest));
});
export default List;